import { useEffect, useState } from "react";
import { api } from "@utils/index";
import WelcomePage from "./components/WelcomePage";
import RatingPage from "./components/RatingPage";
import FeedbackPage from "./components/Feedback";
import ThankYouPage from "./components/ThankYou";
import { useNavigate } from "react-router-dom";

const Steps = {
	Welcome: "welcome",
	Rating: "rating",
	Feedback: "feedback",
	ThankYou: "thankyou",
};

const errorMessages = {
	804: "我們已收到您的回饋",
};

const errorMessagesDescription = {
	804: "親愛的貴賓，感謝您對我們的支持與寶貴意見！我們會持續努力，讓您的每次購物都更滿意。",
};
export default function NpsPage() {
	const navigate = useNavigate();
	const [step, setStep] = useState(Steps.Welcome);
	const [rating, setRating] = useState(0);
	const [showError, setShowError] = useState(false);
	const [feedbackText, setFeedbackText] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [memberData, setMemberData] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);
	const [errorMessageDescription, setErrorMessageDescription] = useState(null);

	const getTokenFromUrl = () => {
		const queryParams = new URLSearchParams(window.location.search);
		return queryParams.get("token");
	};

	const goNext = async () => {
		if (step === Steps.Rating) {
			if (rating === 0) {
				setShowError(true);
				return;
			}
			setShowError(false);
			setStep(Steps.Feedback);
			return;
		}

		if (step === Steps.Feedback) {
			setStep(Steps.ThankYou);
			try {
				await api.post("/nps/set-survey", {
					source: rating,
					comment: feedbackText,
					token: localStorage.getItem("token"),
				});
			} catch (error) {
				console.error("提交問卷失敗:", error);
			}
		}

		if (step === Steps.Welcome) setStep(Steps.Rating);
	};
	const getMemberCenter = async () => {
		try {
			setIsLoading(true);
			const token = localStorage.getItem("token");
			const inputData = {
				token: token,
			};
			const data = await api.post("/nps/get-survey", inputData);
			setMemberData(data);
		} catch (error) {
			const code = error.response?.data?.error?.code;

			const message =
				code && errorMessages[code] === "我們已收到您的回饋"
					? errorMessages[code]
					: "問卷填寫已截止";

			const messageDescription =
				code &&
				errorMessagesDescription[code] ===
					"親愛的貴賓，感謝您對我們的支持與寶貴意見！我們會持續努力，讓您的每次購物都更滿意。"
					? errorMessagesDescription[code]
					: "親愛的貴賓，感謝您對我們的支持。本次問卷已截止，期待未來再次聽見您的聲音。";

			setErrorMessage(message);
			setErrorMessageDescription(messageDescription);
		} finally {
			setIsLoading(false);
		}
	};
	const goBack = () => {
		if (step === Steps.Feedback) setStep(Steps.Rating);
	};

	const handleReset = () => {
		setRating(0);
		setShowError(false);
		navigate("/");
	};

	useEffect(() => {
		const token = getTokenFromUrl();
		if (token) {
			localStorage.setItem("token", token);
		}
		getMemberCenter();
	}, []);

	return (
		<>
			{isLoading ? (
				<div className="pointer-events-none fixed left-0 top-0 z-[1000] flex h-svh w-full items-center justify-center bg-white">
					<img
						alt={"reload"}
						className="h-[6rem] w-[6rem] rounded-md bg-white p-4 opacity-100"
						src={window.assetUrl("/images/liff/loading.gif")}
					/>
				</div>
			) : (
				<>
					{step === Steps.Welcome && (
						<WelcomePage
							onStart={() => setStep(Steps.Rating)}
							memberData={memberData}
							errorMessage={errorMessage}
							errorMessageDescription={errorMessageDescription}
						/>
					)}

					{step === Steps.Rating && (
						<RatingPage
							rating={rating}
							memberData={memberData}
							setRating={setRating}
							showError={showError}
							setShowError={setShowError}
							goNext={goNext}
						/>
					)}

					{step === Steps.Feedback && (
						<FeedbackPage
							feedbackText={feedbackText}
							setFeedbackText={setFeedbackText}
							goNext={goNext}
							goBack={goBack}
						/>
					)}

					{step === Steps.ThankYou && (
						<ThankYouPage handleReset={handleReset} />
					)}
				</>
			)}
		</>
	);
}
